import { gql } from 'graphql-request'
import { z } from 'zod'
import { getVaaGQLClient } from './utils/vaaGQLClient'
import { flightFragment, flightSchema } from './models/flight'
import { farePriceCurrencySchema } from './searchFlights'

const summaryFareSchema = z.object({
  passengerType: z.enum(['ADULT', 'TEEN', 'CHILD', 'INFANT']),
  quantity: z.number(),
  price: z.object({
    amountIncludingTax: z.number(),
    currency: farePriceCurrencySchema,
    awardPoints: z.string(),
  }),
})

export type SummaryFare = z.infer<typeof summaryFareSchema>

const searchSummaryResultSchema = z.object({
  searchSummary: z.object({
    flights: z.array(flightSchema),
    fareCalculationSummary: z.object({
      fares: z.array(summaryFareSchema),
    }),
  }),
})

type SearchSummaryResponse = z.infer<typeof searchSummaryResultSchema>

const searchSummaryQueryDocument = gql`
  query SearchSummary($request: SearchSummaryRequestInput!) {
    searchSummary(request: $request) {
      id
      flights {
        ...FlightFragment
      }
      fareCalculationSummary {
        fares {
          passengerType
          quantity
          price {
            amountIncludingTax
            awardPoints
            currency
          }
        }
      }
    }
  }

  ${flightFragment(false)}
`

export async function getSearchSummary(basketId: string, offerId: string) {
  const result = await getVaaGQLClient().request<SearchSummaryResponse>({
    document: searchSummaryQueryDocument,
    variables: {
      request: {
        basketId,
        offerId,
      },
    },
  })

  const {
    searchSummary: { flights, fareCalculationSummary },
  } = searchSummaryResultSchema.parse(result)

  return {
    flights,
    fares: fareCalculationSummary.fares,
  }
}
